import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import '../../Components/dashboard.css';
import { getFeedback } from '../../../redux';
import FeedbackTile from '../FeedbackTile';

function Responded (props) {

    const navigate = useNavigate();
    const {
        getFeedback,
        feedback,
        history,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
        getFeedback();
    }, []);

    const redirectToDashboard = () => {
        navigate("/admin")
    }

    const getMappedFeedback = () => {
        return feedback && feedback
                    .filter(feedback => feedback.response)
                    .map((response, index) => {
                        return  <div className="tileContainer feedbackContainer" key={index + "mapResponseContainer"} >
                                    <FeedbackTile
                                        key={index + "response"}
                                        thisResponse={response}
                                    />
                                </div>
        });
    }

    return (
        <div className="dashboard">
            <button onClick={redirectToDashboard} className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </button>
            <h3 style={{marginTop: "50px"}}>Responded Feedback</h3>
            <div className="tiles">
                {getMappedFeedback()}
            </div>
        </div>
    );
}

export default connect(state => state.root, { getFeedback })(Responded);
